import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEvidenceTag = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 10 15",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M10 0H0v15l5-5 5 5V0z" })
});
export default SvgEvidenceTag;
